import { GearTypeEnum } from './../types/equipment';

import { ApiResponse } from "../types/api";
import { NodeModel } from "../types/node";
import Base from "./base";

class BuoyAPI extends Base {
	constructor(token: string) {
		super(token, "/api/node");
	}

	async addNode(buoyId: string, buoyName: string, gearType: GearTypeEnum): Promise<ApiResponse<NodeModel>> {
		return await this.postJsonWithQueryParams("/", "POST", {
			nodeId: buoyId,
			name: buoyName,
			gearType: gearType,
		});
	}

	async updateNode(buoyId: string, buoyName: string): Promise<ApiResponse<NodeModel>> {
		return await this.postJsonWithQueryParams("/", "PATCH", {
			nodeId: buoyId,
			name: buoyName,
		});
	}

	async removeNode(buoyId: string): Promise<ApiResponse<NodeModel>> {
		return await this.postJsonWithQueryParams(`/${buoyId}`, "DELETE");
	}

	async getNodes(): Promise<ApiResponse<NodeModel[]>> {
		return await this.fetchJsonWithQueryParams("/", "GET");
	}
}

export default BuoyAPI;
